import { minBreakpoints, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const footerSections = css`
  padding: 0 ${spacing.md}px;
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0 ${spacing.xl}px;
    `,
  )};
`;

export const firstSection = css`
  background-color: var(--tertiary-coral-10);
`;

export const secondSection = css`
  background-color: var(--neutral-black-10);
`;

export const thirdSection = css`
  background-color: var(--neutral-black-base);
`;

export const footerInner = css`
  max-width: ${pxToRem(minBreakpoints.XL)};
  margin: 0 auto;
`;

export const appSection = css`
  display: flex;
  justify-content: space-around;
  text-align: center;
  flex-direction: column;
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: 0 ${spacing.xl}px;
      flex-direction: row;
    `,
  )};
`;

export const appContainer = css`
  border-bottom: 1px solid var(--neutral-black-30);
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      border-bottom: 0 none;
    `,
  )};
`;

export const paymentSection = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: 0;
      flex-direction: row;
    `,
  )};
`;

export const localePanel = css`
  width: 100%;
  padding: ${spacing.xxl}px 0;
  border-bottom: 1px solid var(--neutral-black-30);

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: ${pxToRem(260)};
      border-bottom: 0 none;
    `,
  )};
`;

export const localePanelHeading = css`
  ${theme.responsiveText.HEADING.XS}
  ${primarySemiBoldFont}
`;

export const localePanelFlag = css`
  margin-left: auto;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-left: ${spacing.xs}px;
    `,
  )};
`;

export const localePanelButton = css`
  margin-left: ${spacing.md}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-left: auto;
    `,
  )};
`;
